import {BridgeHelper} from "./bridgeHelper";
import {GlobalConfig} from "../common/appConfig";
import {isInApp} from "../bridge/bridge_sdk";

export function mPrint(...data: any[]) {
    if (isInApp) {
        BridgeHelper.logInfo(...data)
    } else {
        GlobalConfig.isDebug && console.log(...data)
    }
}
